import {
  TAG_BATTERY_STATUS_00,
  TAG_BATTERY_STATUS_01,
  TAG_BATTERY_STATUS_10,
  TAG_BATTERY_STATUS_11,
  TAG_BATTERY_STATUS_0000,
  TAG_BATTERY_STATUS_0001,
  TAG_BATTERY_STATUS_0010,
  TAG_BATTERY_STATUS_0100,
  TAG_BATTERY_STATUS_1000,
  TAG_BATTERY_STATUS_0,
  TAG_BATTERY_STATUS_1,
  TAG_CHARGER_STATUS_00,
  TAG_CHARGER_STATUS_01,
  TAG_CHARGER_STATUS_10,
  KEY_CAN_COMMUNICATION_ERROR,
  KEY_NO_ERROR,
  KEY_CELL_UNDER_VOLTAGE,
  KEY_CELL_OVER_VOLTAGE,
  KEY_OVER_TEMPERATURE_ERROR,
  KEY_MAIN_CONTACTOR_FAULTY_ERROR,
  KEY_SOC_ERROR,
  KEY_DC_BUS_OVER_CURRENT_ERROR,
  KEY_CELLS_BALANCING_ERROR,
  KEY_SLAVE_DEAD_ERROR,
  KEY_FAULTY_CHARGING_ERROR,
  KEY_REC_FAN_ERROR,
  KEY_REC_OVER_TEMPERATURE_ERROR,
  KEY_REC_OUTPUT_OVER_VOLTAGE_ERROR,
  KEY_REC_COMMAND_NOT_SEND_ERROR,
  KEY_REC_POWER_LIMIT_FLAG_ERROR,
  KEY_REC_INPUT_PHASE_LOST_ERROR,
  KEY_REC_INPUT_PHASE_UNBALANCE_ERROR,
  KEY_REC_INPUT_UNDER_VOLTAGE_ERROR,
  KEY_REC_INPUT_OVER_VOLTAGE_ERROR,
  KEY_REC_PFC_OFF_ERROR,
  KEY_OVER_LOAD_ERROR,
  KEY_SHORT_CIRCUIT_ERROR,
  KEY_OTW_ERROR,
  KEY_SOW_ERROR,
} from "./Constants";

export const decodeBatteryStatus = (batteryStatus) => {
  let batteryStatus_1 = "";
  let batteryStatus_2 = "";
  let batteryStatus_3 = "";

  if ((batteryStatus & 0x03) == 0) {
    //  battery_status_00
    batteryStatus_1 = TAG_BATTERY_STATUS_00;
  }
  if ((batteryStatus & 0x03) == 0x01) {
    //battery_status_01

    batteryStatus_1 = TAG_BATTERY_STATUS_01;
  }
  if ((batteryStatus & 0x03) == 0x02) {
    //battery_status_10
    batteryStatus_1 = TAG_BATTERY_STATUS_10;
  }
  if ((batteryStatus & 0x03) == 0x03) {
    //battery_status_11
    batteryStatus_1 = TAG_BATTERY_STATUS_11;
  }
  if ((batteryStatus & 0x3c) == 0) {
    //battery_status_0000
    batteryStatus_2 = TAG_BATTERY_STATUS_0000;
  }
  if ((batteryStatus & 0x3c) == 0x04) {
    //battery_status_0001
    batteryStatus_2 = TAG_BATTERY_STATUS_0001;
  }
  if ((batteryStatus & 0x3c) == 0x08) {
    //battery_status_0010
    batteryStatus_2 = TAG_BATTERY_STATUS_0010;
  }
  if ((batteryStatus & 0x3c) == 0x10) {
    //battery_status_0100
    batteryStatus_2 = TAG_BATTERY_STATUS_0100;
  }
  if ((batteryStatus & 0x3c) == 0x20) {
    //battery_status_1000
    batteryStatus_2 = TAG_BATTERY_STATUS_1000;
  }
  if ((batteryStatus & 0x40) == 0) {
    //battery_status_0100
    batteryStatus_3 = TAG_BATTERY_STATUS_0;
  }
  if ((batteryStatus & 0x40) == 0x40) {
    //battery_status_1000
    batteryStatus_3 = TAG_BATTERY_STATUS_1;
  }
  //Contactor Status,Cell Balancing, Weekend Cycle
  return [batteryStatus_1, batteryStatus_2, batteryStatus_3];
};

export const decodeChargingStatus = (charingStaus) => {
  let _chargingStatus = "";
  
  if ((charingStaus & 0x03) == 0) {
    _chargingStatus = TAG_CHARGER_STATUS_00;
  }
  if ((charingStaus & 0x03) == 0x01) {
    _chargingStatus = TAG_CHARGER_STATUS_00;
  }
  if ((charingStaus & 0x03) == 0x02) {
    _chargingStatus = TAG_CHARGER_STATUS_01;
  }
  
  console.log('Charging Status:==================================>',charingStaus)
  return _chargingStatus;
};

export const decodeError = (error) => {
  let err = "";

  if (error == 0) err = KEY_NO_ERROR;

  if ((error & 1) != 0) {
    err = KEY_CELL_UNDER_VOLTAGE;
  }
  if ((error & 2) != 0) {
    err = KEY_CELL_OVER_VOLTAGE;
  }
  if ((error & 4) != 0) {
    err = KEY_OVER_TEMPERATURE_ERROR;
  }
  if ((error & 8) != 0) {
    err = KEY_CAN_COMMUNICATION_ERROR;
  }
  if ((error & 16) != 0) {
    err = KEY_MAIN_CONTACTOR_FAULTY_ERROR;
  }
  if ((error & 32) != 0) {
    err = KEY_SOC_ERROR;
  }
  if ((error & 64) != 0) {
    err = KEY_DC_BUS_OVER_CURRENT_ERROR;
  }
  if ((error & 128) != 0) {
    err = KEY_CELLS_BALANCING_ERROR;
  }
  return err;
};

export const decodeError2 = (error) => {
  let err = "";

  if (error == 0) err = KEY_NO_ERROR;

  if ((error & 1) != 0) {
    err = KEY_SLAVE_DEAD_ERROR;
  }
  if ((error & 2) != 0) {
    err = KEY_FAULTY_CHARGING_ERROR;
  }
  return err;
};

export const recDecoderError1 = (error) => {
  let err = "";

  if (error == 0) err = KEY_NO_ERROR;

  if ((error & 1) != 0) {
    err = KEY_REC_FAN_ERROR;
  }
  if ((error & 2) != 0) {
    err = KEY_REC_OVER_TEMPERATURE_ERROR;
  }
  if ((error & 4) != 0) {
    err = KEY_REC_OUTPUT_OVER_VOLTAGE_ERROR;
  }
  if ((error & 8) != 0) {
    err = KEY_REC_COMMAND_NOT_SEND_ERROR;
  }
  if ((error & 16) != 0) {
    err = KEY_REC_POWER_LIMIT_FLAG_ERROR;
  }
  if ((error & 32) != 0) {
    err = KEY_REC_INPUT_PHASE_LOST_ERROR;
  }
  if ((error & 64) != 0) {
    err = KEY_REC_INPUT_PHASE_UNBALANCE_ERROR;
  }
  if ((error & 128) != 0) {
    err = KEY_REC_INPUT_UNDER_VOLTAGE_ERROR;
  }
  return err;
};

export const recDecoderError2 = (error) => {
  let err = "";

  if (error == 0) err = KEY_NO_ERROR;

  if ((error & 1) != 0) {
    err = KEY_REC_INPUT_OVER_VOLTAGE_ERROR;
  }
  if ((error & 2) != 0) {
    err = KEY_REC_PFC_OFF_ERROR;
  }
  return err;
};

export const decodeInverterError = (error) => {
  let Err = "";

  if (error == 0) {
    Err = KEY_NO_ERROR;
  }

  if ((error & 1) != 0) {
    Err = KEY_OVER_TEMPERATURE_ERROR;
  }
  if ((error & 2) != 0) {
    Err = KEY_OVER_TEMPERATURE_ERROR;
  }
  if ((error & 4) != 0) {
    Err = KEY_OVER_LOAD_ERROR;
  }
  if ((error & 8) != 0) {
    Err = KEY_SHORT_CIRCUIT_ERROR;
  }
  if (error == 0x10) {
    Err = KEY_OTW_ERROR;
  }
  if (error == 0x20) {
    Err = KEY_SOW_ERROR;
  } else {
    Err = "No Error";
  }

  return Err;
};
